import React, { useState } from "react";
import { Button } from "primereact/button";
import { useGlobalContext } from "../../../Config";
import FormBusquedaProductos from "../../draft/components/FormBusquedaProductos";
import ProductosDisponiblesTable from "../../availableProduct/components/ProductosDisponiblesTable";
import UseScrollOnStateChange from "../../../shared/hooks/useScrollOnStateChange.js";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import StepByStep from "../../../shared/components/StepByStep";
import Loader from "../../../shared/ui/Loader";
import FormCrearListaEspera from "../../waitList/components/FormCrearListaEspera";
import { validateFiltrosProductosCabecera } from "../../../utilities/Helper";
import { getProductosByFiltro } from "../../../services/CotizacionService.js";
import useClienteCotizacion from "../hooks/useClienteCotizacion.js";
import useIsMobile from "../../../shared/hooks/useIsMobile.js";
import {
  mapEmpresas,
  mapTipos,
  mapDateFilters,
} from "../../../utilities/filtrosBusqueda.js";

const items = [
  {
    label: "Seleccione Cliente",
  },
  {
    label: "Seleccione Productos",
  },
  {
    label: "Añada Subproductos Y Servicios",
  },
  {
    label: "Defina Tarifas",
  },
];
const CotizacionSelectProductos = (props) => {
  const [displayDialog, setDisplayDialog] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idCliente = parseInt(searchParams.get("idCliente"));
  const idCotizacion = parseInt(searchParams.get("idCotizacion"));
  const selected = searchParams.get("selected");
  const activeIndex = parseInt(searchParams.get("activeIndex"));
  const [carro, setCarro] = useState([]);
  const { baseUrl } = useGlobalContext();
  const [empresa, setEmpresa] = useState(null);
  const empresas = [
    { name: "TODAS", value: "TODAS" },
    { name: "ALTAMIRA", value: "Altamira" },
    { name: "LA SIEMBRA", value: "LA SIEMBRA" },
  ];
  const [showProductosEncontrados, setShowProductosEncontrados] =
    useState(false);
  const [tipoProducto, setTipoProducto] = useState("");
  const [tiposProducto, setTiposProducto] = useState([]);

  const navigate = useNavigate();

  const [desde, setDesde] = useState(null);
  const [hasta, setHasta] = useState(null);
  const [regularizarCotizacion, setRegularizarCotizacion] = useState(false);
  const [rowClick] = useState(true);

  const [loading, setLoading] = useState(false);
  const [productosDisponibles, setProductosDisponibles] = useState([]);

  const { cliente } = useClienteCotizacion(
    baseUrl,
    idCliente,
    idCliente && selected === "true" && activeIndex
  );

  const searchProductos = async () => {
    try {
      if (!isValidFiltrosProductos()) {
        return;
      }

      resetCarro();
      setProductosDisponibles([]);
      const empresasArray = mapEmpresas(empresa);
      const tiposArray = mapTipos(tipoProducto);
      const { desdeFiltro, hastaFiltro } = mapDateFilters(desde, hasta);
      setDesdeFiltro(desdeFiltro);
      setHastaFiltro(hastaFiltro);

      setLoading(true);
      setShowProductosEncontrados(true);

      const data = await getProductosByFiltro(baseUrl, {
        empresas: empresasArray,
        fechaInicio: desdeFiltro,
        fechaTermino: hastaFiltro,
        tipos: tiposArray,
      });

      if (Array.isArray(data.productos)) {
        setProductosDisponibles(data.productos);
      } else {
        console.error("Data.productos no es array:", data.productos);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const isValidFiltrosProductos = () => {
    if (!checkCabeceraFiltrosProductos()) {
      return false;
    }
    return true;
  };

  const checkCabeceraFiltrosProductos = () => {
    const { isValid, errorMessage } = validateFiltrosProductosCabecera({
      empresa,
      tipoProducto,
      desde,
      hasta,
      regularizarCotizacion,
    });

    if (errorMessage) {
      alert(errorMessage);
    }

    return isValid;
  };

  const [desdeFiltro, setDesdeFiltro] = useState("");
  const [hastaFiltro, setHastaFiltro] = useState("");

  const resetCarro = () => {
    setCarro([]);
  };

  const isMobile = useIsMobile();

  const selectSubProductsAndServices = () => {
    if (carro.length <= 0) {
      alert("Seleccione al menos un producto");
    } else {
      // Update each item in carro to include tarifa_base attribute
      const updatedCarro = carro.map((item) => ({
        ...item,
        tarifa_base: item.tarifa_base,
      }));

      const carroEncoded = encodeURIComponent(JSON.stringify(updatedCarro));


      const newURL =
        `/selectSubProductosYServicios?activeIndex=2&selectedItems=${carroEncoded}&idCliente=${cliente.id}&selected=true&desde=${desdeFiltro}&hasta=${hastaFiltro}&idCotizacion=${idCotizacion}`;
      navigate(newURL);
    }
  };
  UseScrollOnStateChange(productosDisponibles, "productosDataTable");

  return (
    <div className="card">
      {!isMobile && activeIndex && <StepByStep activeIndex={activeIndex} items={items}/>}

      {cliente && (
        <>
          <FormBusquedaProductos
            baseUrl={baseUrl}
            cliente={cliente}
            empresa={empresa}
            setEmpresa={setEmpresa}
            empresas={empresas}
            tipoProducto={tipoProducto}
            setTipoProducto={setTipoProducto}
            tiposProducto={tiposProducto}
            setTiposProducto={setTiposProducto}
            desde={desde}
            setDesde={setDesde}
            hasta={hasta}
            setHasta={setHasta}
            searchProductos={searchProductos}
            idCotizacion={idCotizacion}
            loading={loading}
            regularizarCotizacion={regularizarCotizacion}
            setRegularizarCotizacion={setRegularizarCotizacion}
          />
        </>
      )}
      {showProductosEncontrados && (
        <>
          {loading ? (
            <>
              <Loader></Loader>
            </>
          ) : (
            <div className="field col-12 md:col-12 mt-2">
              <ProductosDisponiblesTable
                productosDisponibles={productosDisponibles}
                loading2={loading}
                rowClick={rowClick}
                carro={carro}
                setCarro={setCarro}
                desdeFiltro={desdeFiltro}
                hastaFiltro={hastaFiltro}
                setDisplayDialog={setDisplayDialog}
                nombreEmpresa={empresa}
              />
            </div>
          )}

          <div
            className="field col-12 md:col-12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              label="Confirmar"
              icon="pi pi-check"
              className="mr-2 mb-2 p-button-success p-button-rounded"
              onClick={selectSubProductsAndServices}
              style={{ width: "400px" }}
              visible={!loading}
              raised
            />
          </div>
        </>
      )}
        
      <FormCrearListaEspera
        visible={displayDialog}
        onHide={() => setDisplayDialog(false)}
        idCliente={idCliente}
        setDisplayDialog={setDisplayDialog}
        empresa={empresa}
        setEmpresa={setEmpresa}
        empresas={empresas}
        tipoProducto={tipoProducto}
        setTipoProducto={setTipoProducto}
        tiposProducto={tiposProducto}
        setTiposProducto={setTiposProducto}
        baseUrl={baseUrl}
      />

    </div>
  );
};

export default CotizacionSelectProductos;
